export default "/images/vendor/flag-icon-css/flags/1x1/tw.svg?a72a85cb06aca393b4c6820552923106";